import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@interstate/components/Box';
import { FlexCol } from '@makemydeal/dr-dash-components';
import * as firstPencilActionCreators from '@makemydeal/dr-dash-store/actions/firstPencilActionCreators';
import * as firstPencilSelectors from '@makemydeal/dr-dash-store/selectors/firstPencilSelectors';

import { FirstPencilManualIncentives } from './FirstPencilManualIncentives';
import { FirstPencilProgramsPanel } from './FirstPencilProgramsPanel';
import { FirstPencilIncentiveTotals } from './FirstPencilIncentiveTotals';
import { FirstPencilSelectedLenders } from './FirstPencilSelectedLenders';
import { DEFAULT_FIRST_PENCIL_PROGRAMS_TAB } from './utils';
import type { FirstPencilProgramsOfferType, FirstPencilProgramsTabLeft } from './types';

export const FirstPencilProgramsCompactUI = () => {
    const dispatch = useDispatch();
    const activeOfferType = useSelector(firstPencilSelectors.getActiveProgramsOfferType) ?? DEFAULT_FIRST_PENCIL_PROGRAMS_TAB;

    const handleOfferTypeChange = useCallback(
        (offerType: FirstPencilProgramsOfferType, tabLeft?: FirstPencilProgramsTabLeft) => {
            dispatch(firstPencilActionCreators.offerTypeSwitched(offerType, tabLeft));
        },
        [dispatch]
    );

    return (
        <Box
            data-testid="first-pencil-programs-container"
            sx={{ minHeight: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}
        >
            <FlexCol gap="1rem">
                <FirstPencilManualIncentives offerType={activeOfferType} />
                <FirstPencilProgramsPanel
                    key={activeOfferType}
                    offerType={activeOfferType}
                    onOfferTypeChange={handleOfferTypeChange}
                />
                <FirstPencilIncentiveTotals offerType={activeOfferType} />
            </FlexCol>
            <FirstPencilSelectedLenders />
        </Box>
    );
};
